/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProductGroupDtoFromDiscriminatorValue, type ProductGroupDto } from '../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../models/oDataErrors/index.js';
// @ts-ignore
import { CoolingRegimeProductGroupsRequestBuilderNavigationMetadata, CoolingRegimeProductGroupsRequestBuilderRequestsMetadata, type CoolingRegimeProductGroupsRequestBuilder } from './coolingRegimeProductGroups/index.js';
// @ts-ignore
import { ProductsRequestBuilderNavigationMetadata, ProductsRequestBuilderRequestsMetadata, type ProductsRequestBuilder } from './products/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the collection of ProductGroupDto entities.
 */
export interface WithCodeItemRequestBuilder extends BaseRequestBuilder<WithCodeItemRequestBuilder> {
    /**
     * Provides operations to manage the coolingRegimeProductGroups property of the AapService.ProductGroupDto entity.
     */
    get coolingRegimeProductGroups(): CoolingRegimeProductGroupsRequestBuilder;
    /**
     * Provides operations to manage the products property of the AapService.ProductGroupDto entity.
     */
    get products(): ProductsRequestBuilder;
    /**
     * Get entity from ProductGroupOverview by key
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductGroupDto>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCodeItemRequestBuilderGetQueryParameters> | undefined) : Promise<ProductGroupDto | undefined>;
    /**
     * Get entity from ProductGroupOverview by key
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCodeItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get entity from ProductGroupOverview by key
 */
export interface WithCodeItemRequestBuilderGetQueryParameters {
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Select properties to be returned
     */
    select?: string[];
}
/**
 * Uri template for the request builder.
 */
export const WithCodeItemRequestBuilderUriTemplate = "{+baseurl}/ProductGroupOverview/{code}{?%24expand,%24select}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const WithCodeItemRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "expand": "%24expand",
    "select": "%24select",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCodeItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCodeItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    coolingRegimeProductGroups: {
        requestsMetadata: CoolingRegimeProductGroupsRequestBuilderRequestsMetadata,
        navigationMetadata: CoolingRegimeProductGroupsRequestBuilderNavigationMetadata,
    },
    products: {
        requestsMetadata: ProductsRequestBuilderRequestsMetadata,
        navigationMetadata: ProductsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCodeItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductGroupDtoFromDiscriminatorValue,
        queryParametersMapper: WithCodeItemRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
